import { FileDto } from '../../files/dtos/file.dto';

/**
 * Create vehicle make DTO
 */
export class CreateVehicleMakeDto {
	color?: string;
	uuid!: string;
	name!: string;
	notes?: string;
	externalReference?: string;
	files?: FileDto[];
}
